/**
 * Returns code for download the given file.
 *
 * @returns {boolean}
 */
const downloadFile = (responseBlob, applicationType) => {
	let fileName = responseBlob.headers['content-disposition'];
	fileName = fileName.substring(fileName.indexOf('=') + 1, fileName.length);
	fileName = fileName.indexOf('"') !== -1 ? fileName.substring(1, fileName.length - 1) : fileName;
	const blob = new Blob([responseBlob.data], { type: applicationType });
	const a = document.createElement('a');
	const url = window.URL.createObjectURL(blob);
	a.href = url;
	a.download = fileName;
	a.click();
	window.URL.revokeObjectURL(url);
};

export default downloadFile;
